export default __webpack_public_path__ + "static/media/mosquito.ae3f68e8.svg";